import React from 'react';
import {Modal, Text, TouchableOpacity, View, StyleSheet} from 'react-native';

interface ISortModal {
  visible: boolean;
  onRequestClose: () => void;
  returnOrder: (order: string) => void;
  currentSort?: string;
  onCloseSort: () => void;
}

const SortModal = ({
  visible, 
  onRequestClose, 
  returnOrder, 
  currentSort,
  onCloseSort
}: ISortModal) => {
  return (
    <Modal
      animationType="slide"
      transparent={true}
      visible={visible}
      onRequestClose={onCloseSort}>
      <View style={styles.container}>
        <View style={styles.content}>
          <View style={styles.containerHeader}>
            <TouchableOpacity onPress={onCloseSort}>
              <Text style={styles.subtitle}>Cancelar</Text>
            </TouchableOpacity>
            <Text style={styles.title}>Filtrar</Text>
            <TouchableOpacity onPress={onCloseSort}>
              <Text style={[styles.subtitle, { opacity: 0 }]}>Cancelar</Text>
            </TouchableOpacity>
          </View>

          <TouchableOpacity
            onPress={() => {
              returnOrder('price_asc');
              onCloseSort();
            }}
            style={styles.optionContainer}>
            <Text 
              style={[
                styles.filterDescription,
                currentSort === 'price_asc' && styles.activeText
              ]}>
              Menor Preço
            </Text>
          </TouchableOpacity>

          <TouchableOpacity
            onPress={() => {
              returnOrder('name_asc');
              onCloseSort();
            }}
            style={styles.optionContainer}>
            <Text 
              style={[
                styles.filterDescription,
                currentSort === 'name_asc' && styles.activeText
              ]}>
              Nome de (A - Z)
            </Text>
          </TouchableOpacity>

          <TouchableOpacity
            onPress={() => {
              returnOrder('name_desc');
              onCloseSort();
            }}
            style={styles.optionContainer}>
            <Text 
              style={[
                styles.filterDescription,
                currentSort === 'name_desc' && styles.activeText
              ]}>
              Nome de (Z - A)
            </Text>
          </TouchableOpacity>

          <TouchableOpacity
            onPress={() => {
              returnOrder('price_desc');
              onCloseSort();
            }}
            style={styles.optionContainer}>
            <Text 
              style={[
                styles.filterDescription,
                currentSort === 'price_desc' && styles.activeText
              ]}>
              Maior Preço
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.4)',
    justifyContent: 'flex-end',
  },
  content: {
    backgroundColor: 'white',
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    padding: 20,
  },
  containerHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 20,
  },
  title: {
    fontSize: 16,
    fontWeight: 'bold',
  },
  subtitle: {
    fontSize: 14,
    color: 'blue',
  },
  optionContainer: {
    paddingVertical: 15,
  },
  filterDescription: {
    fontSize: 14,
  },
  activeText: {
    color: 'red',
  },
});

export default SortModal;